import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=3c76f51e&scoped=true&"
import script from "./js/landingPage.js?vue&type=script&lang=js&"
export * from "./js/landingPage.js?vue&type=script&lang=js&"
import style0 from "./LandingPage.vue?vue&type=style&index=0&id=3c76f51e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c76f51e",
  null
  
)

export default component.exports